import {
  type GetWorkerShoppableQualificationResponse,
  type GetWorkerShoppableQualificationsQuery,
  getWorkerShoppableQualificationsQuery,
  type GetWorkerShoppableQualificationsResponse,
  getWorkerShoppableQualificationsResponse,
} from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

interface GetWorkerShoppableQualificationsParams {
  workerId: string;
  queryParams?: GetWorkerShoppableQualificationsQuery;
}

export type ShoppableQualificationIncludedQualification = Exclude<
  NonNullable<NonNullable<GetWorkerShoppableQualificationResponse["included"]>[number]>,
  { type: "worker" }
>;

export function createUseGetWorkerShoppableQualificationsQueryKey(workerId: string) {
  return [
    `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/shoppable-qualifications`,
  ];
}

export function useGetWorkerShoppableQualifications(
  params: GetWorkerShoppableQualificationsParams,
  options: UseGetQueryOptions<GetWorkerShoppableQualificationsResponse> = {}
) {
  const { workerId, queryParams } = params;
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/shoppable-qualifications`,
    requestSchema: getWorkerShoppableQualificationsQuery,
    responseSchema: getWorkerShoppableQualificationsResponse,
    queryParams,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_SHOPPABLE_QUALIFICATIONS_FAILURE,
    },
    ...options,
  });
}
